/* ============================================
   ADEQO — GEDEELDE B2B-PRIJSENGINE (preview)
   --------------------------------------------
   Single source of truth voor client-side B2B-prijsberekening.
   Strip BTW (excl-BTW) + pas BSS-staffelkorting toe op basis van
   window.BSS_B2B.qb.qbRules + window.adeqoCustomer.

   BELANGRIJK: dit is een PREVIEW. De winkelwagen blijft de uiteindelijke
   bron van waarheid (final_line_price). Identieke logica als de
   productpagina-cross-sell; bedoeld om die later te dedupen naar dit bestand.

   API: window.AdeqoB2BPricing
     .isB2B()                                  -> boolean
     .stripVat(cents)                          -> cents (excl btw)
     .unitPriceCents(productId, inclCents, qty) -> cents (B2B-preview unit-prijs)
   ============================================ */
(function () {
  'use strict';

  function stripVat(cents) {
    var rate = (window.adeqoCustomer && window.adeqoCustomer.b2bTaxRate) || 21;
    return Math.round(cents / (1 + rate / 100));
  }

  function customerTags() {
    var tags = (window.adeqoCustomer && window.adeqoCustomer.tags) || [];
    if (typeof tags === 'string') tags = tags.split(',');
    return tags.map(function (t) { return String(t).trim().toLowerCase(); }).filter(Boolean);
  }

  function isB2B() {
    // 1) Theme-tag-check (Liquid). 2) Fallback: BSS heeft een B2B-prijs op de
    // pagina gerenderd -> klant is B2B (zelfde autoriteit als het hoofdproduct).
    if (window.adeqoCustomer && window.adeqoCustomer.isB2B) return true;
    if (document.querySelector('[bss-b2b-product-active="true"]')) return true;
    var p = document.querySelector('.bss-b2b-price-no-vat');
    return !!(p && /\d/.test(p.textContent || ''));
  }

  function bssRules() {
    var qb = window.BSS_B2B && window.BSS_B2B.qb;
    return (qb && Array.isArray(qb.qbRules)) ? qb.qbRules : [];
  }

  function ruleApplies(rule, productId, tags) {
    if (rule.customer_tags) {
      var required = String(rule.customer_tags).split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
      if (required.length > 0) {
        var hasTag = tags.some(function (t) { return required.indexOf(t) !== -1; });
        if (!hasTag) return false;
      }
    }
    var applyTo = parseInt(rule.apply_to, 10);
    if (applyTo === 4 && rule.product_ids) {
      var ids = String(rule.product_ids).split(',').map(function (s) { return s.trim(); });
      if (ids.indexOf(String(productId)) === -1) return false;
    }
    return true;
  }

  function activeRule(productId, tags) {
    var rules = bssRules().filter(function (r) { return ruleApplies(r, productId, tags); });
    if (!rules.length) return null;
    rules.sort(function (a, b) { return (a.priority || 0) - (b.priority || 0); });
    return rules[0];
  }

  function tierForQty(rule, qty) {
    if (!rule || !rule.qty_table) return null;
    for (var i = 0; i < rule.qty_table.length; i++) {
      var t = rule.qty_table[i];
      var to = (t.qty_to == null) ? Infinity : t.qty_to;
      if (qty >= t.qty_from && qty <= to) return t;
    }
    return null;
  }

  // B2B-preview unit-prijs (cents): strip BTW, dan staffelkorting.
  // Niet-B2B / geen regel -> geeft incl-prijs (resp. excl-btw) terug.
  function unitPriceCents(productId, inclCents, qty) {
    if (!isB2B() || !inclCents) return inclCents;
    var exVat = stripVat(inclCents);
    var rule = activeRule(productId, customerTags());
    if (!rule) return exVat;
    var tier = tierForQty(rule, qty || 1);
    if (!tier) return exVat;
    var pct = parseFloat(tier.discount_value) || 0;
    if (pct <= 0) return exVat;
    var dtype = tier.discount_type;
    var isPercent = (dtype === 2 || dtype === 'percent' || dtype === '%' || !dtype);
    if (isPercent) return Math.round(exVat * (100 - pct) / 100);
    return Math.max(0, exVat - Math.round(pct * 100));
  }

  // Bereken de unit-prijs voor één tier-rij (cents).
  function tierUnitCents(exVat, t) {
    var pct = parseFloat(t.discount_value) || 0;
    if (pct <= 0) return exVat;
    var dtype = t.discount_type;
    var isPercent = (dtype === 2 || dtype === 'percent' || dtype === '%' || !dtype);
    if (isPercent) return Math.round(exVat * (100 - pct) / 100);
    return Math.max(0, exVat - Math.round(pct * 100));
  }

  // Volledige staffel-preview voor de B2B-portal Snelbestellen.
  // Geeft: unitCents (huidige staffelprijs), baseCents (ex-btw zonder korting),
  // pct (huidige korting%), tierFrom (ondergrens huidige staffel),
  // next ({from, pct, unitCents} | null), isB2B.
  function previewFor(productId, inclCents, qty) {
    qty = Math.max(1, qty || 1);
    var out = { unitCents: inclCents, baseCents: inclCents, pct: 0, tierFrom: 1, next: null, isB2B: false };
    if (!isB2B() || !inclCents) return out;
    out.isB2B = true;
    var exVat = stripVat(inclCents);
    out.unitCents = exVat;
    out.baseCents = exVat;
    var rule = activeRule(productId, customerTags());
    if (!rule || !rule.qty_table || !rule.qty_table.length) return out;

    var tiers = rule.qty_table.map(function (t) {
      var dtype = t.discount_type;
      var isPercent = (dtype === 2 || dtype === 'percent' || dtype === '%' || !dtype);
      return {
        from: t.qty_from,
        to: (t.qty_to == null ? Infinity : t.qty_to),
        pct: isPercent ? (parseFloat(t.discount_value) || 0) : 0,
        unitCents: tierUnitCents(exVat, t)
      };
    }).sort(function (a, b) { return a.from - b.from; });

    var cur = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].from && qty <= tiers[i].to) { cur = tiers[i]; break; }
    }
    if (cur) { out.unitCents = cur.unitCents; out.pct = cur.pct; out.tierFrom = cur.from; }
    for (var j = 0; j < tiers.length; j++) {
      if (tiers[j].from > qty) { out.next = { from: tiers[j].from, pct: tiers[j].pct, unitCents: tiers[j].unitCents }; break; }
    }
    return out;
  }

  // Zijn de BSS-staffelregels al geladen? (Bepaalt of we zelf kunnen rekenen.)
  function rulesLoaded() {
    return bssRules().length > 0;
  }

  window.AdeqoB2BPricing = {
    isB2B: isB2B,
    stripVat: stripVat,
    unitPriceCents: unitPriceCents,
    previewFor: previewFor,
    rulesLoaded: rulesLoaded
  };
})();
